import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Expense approvals: Accounts (AccessProvisioning.expenseAccounts) or an expense approver.
// UI only - the backend authorizes every voucher and action itself.
const ExpenseApprovalRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user || user.access === undefined) return <div>Loading...</div>;
  const allowed = user.access?.expenseAccounts === true || user.access?.expenseApprover === true;
  return allowed
    ? children
    : <Navigate to={user.primaryRole === 'admin' ? '/admin/dashboard' : '/dashboard'} replace />;
};

export default ExpenseApprovalRoute;
